export function Terms() {
  return (
    <div className="max-w-3xl mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold text-stone-900 dark:text-white mb-2">Terms of Service</h1>
      <p className="text-sm text-stone-500 dark:text-zinc-500 mb-8">Last updated: March 18, 2026</p>

      <div className="prose prose-stone dark:prose-invert prose-sm max-w-none space-y-6">
        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">1. Acceptance of Terms</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            By accessing or using SocialCast ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">2. Description of Service</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            SocialCast is a social media management platform that allows you to connect multiple social media accounts, create and schedule posts, view analytics, and manage your social media inbox from a single interface.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">3. Account Responsibilities</h2>
          <ul className="list-disc pl-5 text-stone-600 dark:text-zinc-400 space-y-1">
            <li>You are responsible for maintaining the security of your account credentials.</li>
            <li>You are responsible for all content posted through your connected social media accounts via SocialCast.</li>
            <li>You must have authorization to connect and post to any social media account you add to SocialCast.</li>
            <li>You must comply with the terms of service of each social media platform you connect.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">4. Acceptable Use</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">You agree not to use SocialCast to:</p>
          <ul className="list-disc pl-5 text-stone-600 dark:text-zinc-400 space-y-1">
            <li>Post content that violates any applicable law or regulation.</li>
            <li>Spam, harass, or send unsolicited content.</li>
            <li>Impersonate others or misrepresent your identity.</li>
            <li>Violate the terms of service of any connected social media platform.</li>
            <li>Attempt to gain unauthorized access to the Service or other users' accounts.</li>
            <li>Use automated systems to abuse platform rate limits or APIs.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">5. Content Ownership</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            You retain full ownership of all content you create and publish through SocialCast. By using the Service, you grant SocialCast a limited license to store, process, and transmit your content solely for the purpose of providing the Service (e.g., publishing posts to your connected accounts).
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">6. AI-Generated Content</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            SocialCast may offer AI-powered features to assist with content creation. AI-generated content is provided as suggestions only. You are solely responsible for reviewing, editing, and approving any AI-generated content before publishing. SocialCast is not responsible for the accuracy, appropriateness, or legality of AI-generated content.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">7. Third-Party Platforms</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            SocialCast integrates with third-party social media platforms. We are not responsible for changes to their APIs, terms of service, or availability. Platform-specific limitations (character limits, media format restrictions, rate limits) are enforced by the respective platforms and may change without notice.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">8. Service Availability</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            We strive to maintain high availability but do not guarantee uninterrupted access to the Service. We may perform maintenance, updates, or modifications that temporarily affect availability. Scheduled posts may fail due to platform outages, expired tokens, or other factors beyond our control.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">9. Limitation of Liability</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            SocialCast is provided "as is" without warranties of any kind. We are not liable for any damages arising from the use of the Service, including but not limited to: failed posts, incorrect scheduling, platform API changes, token expiration, or data loss. Our total liability is limited to the amount you have paid for the Service in the preceding 12 months.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">10. Termination</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            You may terminate your account at any time by contacting us. We may suspend or terminate your account if you violate these terms. Upon termination, your data will be deleted in accordance with our Privacy Policy.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">11. Changes to Terms</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            We may update these terms from time to time. Continued use of the Service after changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-stone-900 dark:text-white">12. Contact</h2>
          <p className="text-stone-600 dark:text-zinc-400 leading-relaxed">
            For questions about these terms, contact us at <a href="mailto:legal@socialcast.dev" className="text-orange-600 dark:text-orange-400 hover:underline">legal@socialcast.dev</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
